import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-labelled-area',
  templateUrl: './labelled-area.component.html',
  styleUrls: ['./labelled-area.component.scss'],
})
export class LabelledAreaComponent {
  @Input() title: string | HTMLElement;
  @Input() maxHeight: string;
  @Input() readonly: boolean;

  constructor() {}
}
